<template>
  <div class="list-box dialog-dom">
    <div class="flex-1 flex flex-col relative">
      <ul
        class="flex items-center justify-end p-2.5 gap-x-3 absolute right-0"
        style="top: -10px; z-index: 99"
      >
        <el-segmented
          v-model="state.params.is_approve"
          :props="{
            label: 'Text',
            value: 'Key',
          }"
          :options="[
            { Key: 0, Text: '待审批' },
            { Key: 1, Text: '已审批' },
          ]"
          :empty-values="[null, undefined, 0]"
          class="c-segmented"
        />
        <el-input
          v-model="state.keywords"
          class="!w-56"
          clearable
          placeholder="关键字"
          @keyup.enter="state.params.keywords = state.keywords"
        >
          <template #suffix>
            <el-icon
              @click="state.params.keywords = state.keywords"
              color="#a2a2a2"
              title="搜索"
              class="font-bold cursor-pointer hover:opacity-60"
              ><Search
            /></el-icon>
          </template>
        </el-input>
      </ul>
      <el-tabs v-model="state.type" class="c-el-tabs-auto-height">
        <el-tab-pane label="接送机安排" name="paiche">
          <c_paiche
            v-if="state.type == 'paiche'"
            :params="state.params"
            :key="state.params?.is_approve"
          />
        </el-tab-pane>
        <el-tab-pane label="司机排班" name="paiban">
          <c_paiban
            v-if="state.type == 'paiban'"
            :params="state.params"
            :key="state.params?.is_approve"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

import c_paiche from "./PaiChe/List.vue";
import c_paiban from "./PaiBan/List.vue";

export default {
  components: {
    c_paiche,
    c_paiban,
  },
  setup() {
    const state = reactive({
      type: "caigou",
      params: {
        is_approve: 0,
      },
    });
    onMounted(() => {});

    return {
      state,
    };
  },
};
</script>

<style lang="scss" scoped></style>
